import React from "react";
import ProfileSettings from "../ProfileSettings";
import { Settings as SettingsIcon } from "lucide-react";

export default function AdminSettings() {
  return (
    <div>
      <h1 className="text-3xl font-display font-black tracking-tight flex items-center gap-2">
        <SettingsIcon className="text-[#ea580c]" /> Admin Settings
      </h1>
      <p className="text-sm text-slate-600 mt-1">Manage your admin profile, photo, and password.</p>
      <ProfileSettings compact />
    </div>
  );
}
